<template>
  <div v-if="visible" class="scan-mask">
    <!-- 顶部栏 -->
    <div class="scan-header">
      <svg viewBox="0 0 24 24" class="back-icon" @click="handleClose">
        <path d="M15 5 L8 12 L15 19" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span class="scan-title">扫一扫</span>
    </div>

    <!-- 摄像头区域 -->
    <div class="camera-wrap">
      <div id="scan-reader" class="scan-reader"></div>
      <!-- 扫描框遮罩 -->
      <div class="scan-frame">
        <span class="corner tl"></span>
        <span class="corner tr"></span>
        <span class="corner bl"></span>
        <span class="corner br"></span>
        <span class="scan-line"></span>
      </div>
      <div class="scan-tip">将二维码放入框内，即可自动扫描</div>
      <div v-if="errorMsg" class="scan-error">{{ errorMsg }}</div>
    </div>
  </div>
</template>

<script>
import { Html5Qrcode } from 'html5-qrcode'

export default {
  name: 'ScanDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      scanner: null,
      started: false,
      errorMsg: ''
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.errorMsg = ''
        this.$nextTick(() => this.startScan())
      } else {
        this.stopScan()
      }
    }
  },
  beforeDestroy() {
    this.stopScan()
  },
  methods: {
    startScan() {
      const el = document.getElementById('scan-reader')
      if (!el) return
      const scanner = new Html5Qrcode('scan-reader')
      this.scanner = scanner
      const width = Math.min(window.innerWidth, window.innerHeight) * 0.7
      scanner.start(
        { facingMode: 'environment' },
        { fps: 10, qrbox: { width: Math.floor(width), height: Math.floor(width) } },
        decodedText => {
          this.$emit('success', decodedText)
          this.handleClose()
        },
        () => { /* 单帧解析失败，忽略 */ }
      ).then(() => {
        this.started = true
      }).catch(err => {
        console.error('启动摄像头失败:', err)
        const name = (err && err.name) || ''
        if (name === 'NotAllowedError' || name === 'PermissionDeniedError') {
          this.errorMsg = '摄像头权限被拒绝，请在浏览器设置中允许使用摄像头后重试'
        } else if (name === 'NotFoundError' || name === 'DevicesNotFoundError') {
          this.errorMsg = '未检测到摄像头设备'
        } else if (name === 'NotReadableError' || name === 'TrackStartError') {
          this.errorMsg = '摄像头被其他应用占用，请关闭后重试'
        } else {
          this.errorMsg = '无法启动摄像头，请检查权限或使用 HTTPS 访问'
        }
      })
    },
    stopScan() {
      if (this.scanner && this.started) {
        this.scanner.stop().then(() => {
          this.scanner.clear()
          this.started = false
        }).catch(() => {})
      }
      this.scanner = null
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.scan-mask {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #000;
  display: flex;
  flex-direction: column;
}
.scan-header {
  position: relative;
  height: calc(100 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
}
.back-icon {
  position: absolute;
  left: calc(30 * var(--w));
  width: calc(48 * var(--w));
  height: calc(48 * var(--w));
}
.scan-title {
  color: #fff;
  font-size: calc(36 * var(--w));
}
.camera-wrap {
  flex: 1;
  position: relative;
  overflow: hidden;
}
.scan-reader {
  width: 100%;
  height: 100%;
}
.scan-reader >>> video {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
}
.scan-frame {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(560 * var(--w));
  height: calc(560 * var(--w));
  pointer-events: none;
}
.corner {
  position: absolute;
  width: calc(56 * var(--w));
  height: calc(56 * var(--w));
  border-color: #2dd5c5;
  border-style: solid;
}
.corner.tl { top: 0; left: 0; border-width: calc(8 * var(--w)) 0 0 calc(8 * var(--w)); }
.corner.tr { top: 0; right: 0; border-width: calc(8 * var(--w)) calc(8 * var(--w)) 0 0; }
.corner.bl { bottom: 0; left: 0; border-width: 0 0 calc(8 * var(--w)) calc(8 * var(--w)); }
.corner.br { bottom: 0; right: 0; border-width: 0 calc(8 * var(--w)) calc(8 * var(--w)) 0; }
.scan-line {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: calc(6 * var(--w));
  background: linear-gradient(90deg, transparent, #2dd5c5, transparent);
  animation: scan-move 2.5s linear infinite;
}
@keyframes scan-move {
  0% { top: 0; }
  50% { top: calc(554 * var(--w)); }
  100% { top: 0; }
}
.scan-tip {
  position: absolute;
  left: 0;
  right: 0;
  bottom: calc(140 * var(--w));
  text-align: center;
  color: rgba(255, 255, 255, 0.85);
  font-size: calc(28 * var(--w));
}
.scan-error {
  position: absolute;
  left: calc(60 * var(--w));
  right: calc(60 * var(--w));
  top: 60%;
  text-align: center;
  color: #ff6b6b;
  font-size: calc(28 * var(--w));
  line-height: 1.6;
}
</style>



// WEBPACK FOOTER //
// src/components/ScanDialog.vue